import { Selector } from 'types';

const getSocketState: Selector<string> = (state) => state.socketState.state;

export default getSocketState;
